import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from "@angular/forms";
import { LunaCoreModule } from "../core/core.module";
import { LunaCommonModule } from "../common/common.module";
import { OnBehalfRoutingModule } from './on-behalf-routing.module';
import { OnBehalfWrapperComponent } from './components/on-behalf-wrapper/on-behalf-wrapper.component';
import { OnBehalfApplicationSelectComponent } from './components/on-behalf-application-select/on-behalf-application-select.component';
import { OnBehalfOrganizationSelectComponent } from './components/on-behalf-organization-select/on-behalf-organization-select.component';
import { OnBehalfGenerateApplicationComponent } from './components/on-behalf-generate-application/on-behalf-generate-application.component';
import { OnBehalfScanningDocumentComponent } from './components/on-behalf-scanning-document/on-behalf-scanning-document.component';


@NgModule({
    declarations: [
        OnBehalfWrapperComponent,
        OnBehalfApplicationSelectComponent,
        OnBehalfOrganizationSelectComponent,      
        OnBehalfGenerateApplicationComponent, OnBehalfScanningDocumentComponent
    ],
    imports: [
        ReactiveFormsModule,
        CommonModule,
        LunaCommonModule,
        LunaCoreModule,
        OnBehalfRoutingModule
    ]
})
export class OnBehalfModule { }
